import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import { allpayments } from 'models/allpayments'; // Importing allpayments model
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing a record table for casino report view.
 * @extends JetView
 */
export default class recordTableCasinoReportView extends JetView {
    /**
     * Configures the datatable view.
     * @returns {Object} Configuration object for the datatable.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service for translations
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function

        return {
            view: 'datatable', // Specifies the view type as datatable
            select: true, // Enables row selection
            columns: [
                // Defines the columns of the datatable
                { id: 'Id', header: 'Id', width: 100, sort: 'int' }, // Column for Id
                {
                    id: 'TransactionId',
                    header: _('Transacción ID'), // Translated header for Transaction ID
                    width: 100,
                    sort: 'int',
                },
                { id: 'Type', header: _('Tipo'), width: 100, sort: 'int' }, // Translated header for Type
                {
                    id: 'Amount',
                    header: _('Valor'), // Translated header for Amount
                    width: 100,
                    format: webix.i18n.priceFormat, // Formatting for price
                    exportType: 'number', // Specifies export type for Amount
                    sort: 'int',
                },
            ],
            loadahead: 0, // Number of rows to load ahead
            datafetch: devConfig.getDefaultDataFetch(), // Default data fetch configuration
            pager: 'pagerA', // Pager configuration
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} grid - The datatable instance.
     */
    init(grid) {
        this.on(this.app, 'user:id', (idUser) => {
            // Event listener for user ID
            grid.load(
                // Loads data into the grid
                devConfig.geturlApi() + // API URL from configuration
                    'null/Report/GetCasinoGamesReportDetail' + // Endpoint for report details
                    '?id=' + // Query parameter for user ID
                    idUser,
            );
        });
    }
}

// FILE DOCUMENTED
